import axios from './http'

// 财务管理模块中供应商数据
export function getFinanceSupplierByUserId (token) {
  return axios({
    method: 'get',
    url: '/api/charge/getFinanceSupplierByUserId',
    headers: {
      'authorization': token
    }
  })
}

export function selectServiceCharge(token,data){
  return axios({
    method: 'POST',
    url: '/api/charge/select',
    data: data,
    headers: {
      'authorization': token
    }
  })
}

export function updateConfirmAt(token,data){
  return axios({
    method: 'POST',
    url: '/api/charge/updateConfirmAt',
    data: data,
    headers: {
      'authorization': token
    }
  })
}

// 服务费钱包数据
export function selectServiceChargeWallet(token,data){
  return axios({
    method: 'POST',
    url: '/api/charge/selectServiceChargeWallet',
    data: data,
    headers: {
      'authorization': token
    }
  })
}

// 发票明细数据
export function findInvoiceInfoBySupplierId(token,data){
  return axios({
    method: 'POST',
    url: '/api/invoice/findInvoiceInfoBySupplierId',
    data: data,
    headers: {
      'authorization': token
    }
  })
}
